import { createFileRoute } from '@tanstack/react-router';

import { createFeatureFlagGuard } from '@/utils/route-guards/feature-flag-guard';

export const Route = createFileRoute('/$org/$agent/demand-response-admin')({
  beforeLoad: async (ctx) => {
    await createFeatureFlagGuard('demand-response-admin')(ctx);
  },
});
